import React, { useEffect, useState } from 'react';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import '../../TargetReport/TableContent/index.css';
import './operations.css';
import { monthNumberToString } from '../../../../utils/monthStringToNumber'

function TableContent({ 
  tableData,
  totalizarColuna,
 }) {
  const formatter = new Intl.NumberFormat('pt-BR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  const formatCurrency = (e) => {
    return (
      <>
        <div style={{ display: 'flex', justifyContent: 'space-between', padding: '0px 5px' }}>
          <span>R$</span>
          <span>{e ? formatter.format(e) : '0,00'}</span>
        </div>
      </>
    );
  }

  const formatPorcentageCDI = (e) => {
    return (
      <>
        <div style={{ display: 'flex', justifyContent: 'space-between', padding: '0px 5px' }}>
          <span></span>
          <span>{e ? Number(e).toFixed(4) + '%' : '0.0000%'}</span>
        </div>
      </>
    );
  }

  const formatPorcentage = (e) => {
    return (
      <>
        <div style={{ display: 'flex', justifyContent: 'space-between', padding: '0px 5px' }}>
          <span></span>
          <span>{e ? Number(e).toFixed(2) + '%' : '0.00%'}</span>
        </div>
      </>
    );
  }

  const formatCell = (e) => {
    return (
      <>
        <div style={{ display: 'flex', justifyContent: 'space-between', padding: '0px 5px' }}>
          <span></span>
          <span>{e ? e : '0'}</span>
        </div>
      </>
    );
  }

  const dataTableVolumeOperado = tableData?.map(function (item, index) {
    return (
      <TableCell align="left">{formatCurrency(item.valorNotasFiscais)}</TableCell>
    );
  });

  const dataTableReceita = tableData?.map(function (item, index) {
    return (
      <TableCell align="left">{formatCurrency(item.receitaBruta)}</TableCell>
    );
  });

  const dataTableTaxaMedia = tableData?.map(function (item, index) {
    return (
      <TableCell align="left">{formatPorcentage(item.taxa)}</TableCell>
    );
  });
  const dataTablePrazoMedio = tableData?.map(function (item, index) {
    return (
      <TableCell align="left">{formatCell(item.prazoMedio)}</TableCell>
    );
  });
  const dataTableCdi = tableData?.map(function (item, index) {
    return (
      <TableCell align="left">{formatPorcentageCDI(item.cdisValor)}</TableCell>
    );
  });
  const dataTableRetornoCdi = tableData?.map(function (item, index) {
    return (
      <TableCell align="left">{formatPorcentage(item.retornoSobreCdi)}</TableCell>
    );
  });
  const dataTablePropostasEfetuadas = tableData?.map(function (item, index) {
    return (
      <TableCell align="left">{formatCell(item.qtdAntecipacoesFeitas)}</TableCell>
    );
  });
  const dataTableOperacoesFechadas = tableData?.map(function (item, index) {
    return (
      <TableCell align="left">{formatCell(item.qtdAntecipacoesAprovadas)}</TableCell>
    );
  });

  const dateHeaderColumn = tableData?.map(function (item, index) {
    return (
      <>
        <TableCell
          style={{ color: 'white', fontWeight: 'bold' }}
          key={item.ancoraId}
          align="center"
        >
          {`${monthNumberToString(item.mes)} ${item.ano}`}
        </TableCell>
      </>
    );
  });

  return (
    <>
      <div
        className="report-tables"
        style={{
          margin: '0px 45px 0px 50px',
          zIndex: '0',
          position: 'relative',
          justifyContent: 'start',
          flexWrap: 'wrap',
          display: 'flex',
          overflowX: 'auto',
        }}
      >
        <Table
          style={{
            backgroundColor: 'white',
            marginBottom: '20px',
            boxShadow:
              '0px 3px 1px -2px rgba(0,0,0,0.2),0px 2px 2px 0px rgba(0,0,0,0.14),0px 1px 5px 0px rgba(0,0,0,0.12)',
          }}
        >
          <TableHead style={{ backgroundColor: '#232C63' }}>
            <TableRow>
              <TableCell style={{ color: 'white', fontWeight: 'bold' }} align="center">
                Informação
              </TableCell>
              {dateHeaderColumn}
              <TableCell style={{ color: 'white', fontWeight: 'bold' }} align="center">
                Soma
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow style={{ backgroundColor: '#EEEEEE' }}>
              <TableCell style={{ fontWeight: 'bold' }} align="left">Volume Operado</TableCell>
              {dataTableVolumeOperado}
              <TableCell style={{ backgroundColor: '#C4C4C4', fontWeight: 'bold' }} align="center">
                {formatCurrency(totalizarColuna.valorNotasFiscais)}
              </TableCell>
            </TableRow>
            <TableRow style={{ backgroundColor: '#white' }}>
              <TableCell style={{ fontWeight: 'bold' }} align="left">Receita</TableCell>
              {dataTableReceita}
              <TableCell style={{ backgroundColor: '#C4C4C4', fontWeight: 'bold' }} align="center">
                {formatCurrency(totalizarColuna.receitaBruta)}
              </TableCell>
            </TableRow>
            <TableRow style={{ backgroundColor: '#EEEEEE' }}>
              <TableCell style={{ fontWeight: 'bold' }} align="left">{'Taxa Média (% ao mês)'}</TableCell>
              {dataTableTaxaMedia}
              <TableCell style={{ backgroundColor: '#C4C4C4', fontWeight: 'bold' }} align="center">
                {formatPorcentage(totalizarColuna.taxa)}
              </TableCell>
            </TableRow>
            <TableRow style={{ backgroundColor: '#white' }}>
              <TableCell style={{ fontWeight: 'bold' }} align="left">Prazo Médio Operação</TableCell>
              {dataTablePrazoMedio}
              <TableCell style={{ backgroundColor: '#C4C4C4', fontWeight: 'bold' }} align="center">
                {formatCell(totalizarColuna.prazoMedio)}
              </TableCell>
            </TableRow>
            <TableRow style={{ backgroundColor: '#EEEEEE' }}>
              <TableCell style={{ fontWeight: 'bold' }} align="left">CDI</TableCell>
              {dataTableCdi}
              <TableCell style={{ backgroundColor: '#C4C4C4', fontWeight: 'bold' }} align="center">
                {formatPorcentageCDI(totalizarColuna.cdisValor)}
              </TableCell>
            </TableRow>
            <TableRow style={{ backgroundColor: '#white' }}>
              <TableCell style={{ fontWeight: 'bold' }} align="left">Retorno Sobre CDI</TableCell>
              {dataTableRetornoCdi}
              <TableCell style={{ backgroundColor: '#C4C4C4', fontWeight: 'bold' }} align="center">
                {formatPorcentage(totalizarColuna.retornoLiquidoCdi)}
              </TableCell>
            </TableRow>
            <TableRow style={{ backgroundColor: '#EEEEEE' }}>
              <TableCell style={{ fontWeight: 'bold' }} align="left">Propostas Efetuadas</TableCell>
              {dataTablePropostasEfetuadas}
              <TableCell style={{ backgroundColor: '#C4C4C4', fontWeight: 'bold' }} align="center">
                {formatCell(totalizarColuna.qtdAntecipacoesFeitas)}
              </TableCell>
            </TableRow>
            <TableRow style={{ backgroundColor: '#white' }}>
              <TableCell style={{ fontWeight: 'bold' }} align="left">Operações Fechadas</TableCell>
              {dataTableOperacoesFechadas}
              <TableCell style={{ backgroundColor: '#C4C4C4', fontWeight: 'bold' }} align="center">
                {formatCell(totalizarColuna.qtdAntecipacoesAprovadas)}
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </div>
      <div
        style={{
          marginTop: '20px',
          zIndex: '0',
          position: 'relative',
          justifyContent: 'start',
        }}
      ></div>
    </>
  );
}

export default TableContent;
